import { FormControl } from "@angular/forms";

export function carValidator(control: FormControl) {
    if (!control?.value) return null;

    const carRegex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]{16,41}$/;
    
    if (!carRegex.test(control.value)) {
        return { car: true };
    } 

    return null;
}